import React from "react";
import Routers from "./router";
import LoginProvider from "./front/Context/LoginContext";

import { isTokenExpired } from "./front/components/Common/tokenExpiration";
function App() {
  return (
    <div className="App">
      <LoginProvider>
        <Routers />
      </LoginProvider>
    </div>
  );
}

export default App;
